import { Button, Image } from "antd";
import React, { useEffect, useState } from "react";
import "./index.less";
import lineSVG from "./icons/line.svg";
import { WindowsSystemBtnItem } from "../types";
import { useTranslate } from "@obsbot/remo-i18n";
import {
    CloseWindowIcon,
    GameOverLayIcon,
    LogoIconSmall,
    MaximizeIcon,
    MinusIcon,
} from "../../SvgIconCom/TopMenuIcon";

export interface TopMenuProps {
    // 可以定义 TopMenu 的 props 类型
    overlay?: boolean;
    showLogo?: boolean;
    // 点击操作窗口的按钮
    onClickSystemBtn?: (winSystemBtn: WindowsSystemBtnItem) => void;
    handleSearch?: () => void;
    handleOverlay?: () => void;
}
export const TopMenu: React.FC<TopMenuProps> = ({
    overlay,
    showLogo = true,
    onClickSystemBtn,
    handleOverlay,
}) => {
    const t = useTranslate();
    const [isMaximize, setIsMaximize] = useState(false);
    const handleWindow = (action: WindowsSystemBtnItem): void => {
        if (action === "maximize") {
            setIsMaximize(!isMaximize);
        }
        onClickSystemBtn && onClickSystemBtn(action);
    };

    useEffect(() => {
        const bodyEl = document.body;
        const rootEl = bodyEl.querySelector("#root") as HTMLDivElement;
        if (rootEl) {
            if (isMaximize || !window.isElectron) {
                bodyEl.style.borderRadius = "unset";
                rootEl.style.borderRadius = "unset";
            } else {
                bodyEl.style.borderRadius = "10px";
                rootEl.style.borderRadius = "10px";
            }
        }
    }, [isMaximize]);

    return (
        <div className="main-layout-top-menu">
            {/* {search && (
                <Input
                    className="top-menu-search"
                    prefix={<SearchOutlined />}
                    onPressEnter={handleSearch}
                />
            )} */}
            {showLogo && (
                <LogoIconSmall className={`logo-icon ${window.isElectron ? "" : "web-logo"}`} />
            )}
            <div className="right-controls">
                {overlay && window.isElectron && (
                    <Button
                        className="top-menu-overlay"
                        icon={<GameOverLayIcon />}
                        type="text"
                        onClick={() => {
                            console.log("overlay");
                            handleOverlay && handleOverlay();
                        }}
                    >
                        {t("layout.overlay")}
                    </Button>
                )}
                {window.isElectron && (
                    <div className="top-menu-buttons">
                        {overlay && (
                            <Button
                                icon={<Image preview={false} src={lineSVG} />}
                                size="large"
                                style={{ cursor: "default" }}
                                type="link"
                            ></Button>
                        )}
                        <Button
                            icon={<MinusIcon />}
                            size="large"
                            type="link"
                            onClick={handleWindow.bind(this, "minimize")}
                        ></Button>
                        <Button
                            icon={<MaximizeIcon />}
                            size="large"
                            type="link"
                            onClick={handleWindow.bind(this, "maximize")}
                        ></Button>
                        <Button
                            icon={<CloseWindowIcon />}
                            size="large"
                            type="link"
                            onClick={handleWindow.bind(this, "close")}
                        ></Button>
                    </div>
                )}
            </div>
        </div>
    );
};
